export function pushAdminOnlyResponseMessage(message, success = true) {
  const responseMessage = useState('responseMessage');
  const user = useState('user');

  if (user.value.subscription == 'admin') {
    responseMessage.value.message = message;
    responseMessage.value.success = success;
    responseMessage.value.isAdminOnly = true;
    responseMessage.value.key++;
  }
}